module.exports = __webpack_public_path__ + "img/geod_10.8e520a6f.jpg";